import React, { lazy, Suspense } from 'react';

const LazyCustomModule = lazy(() => import('app/components/reamaze/CustomModule'));

export default () => (
  <Suspense fallback={(<div />)}>
    <LazyCustomModule />
  </Suspense>
);
